import * as React from 'react';
import { AuthConsumer } from 'containers';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { browserHistory } from 'react-router';
import { IUserRole } from 'models/shop/members';
//import ExtendedRoute from 'routes/extendedroute';

// when we have router v4 with render function
// export const PrivateRoute = ({ component, ...rest }) => {
//     const renderFn = (Component) => (props) => (
//       <AuthConsumer>
//         {({ isAuthenticated, signinRedirect }) => {
//           if (!!Component && isAuthenticated()) {
//             return <Component {...props} />;
//           } else {
//             signinRedirect();
//             return <span>loading</span>;
//           }
//         }}
//       </AuthConsumer>
//     );

//     return <ExtendedRoute {...rest} render={renderFn(component)} />;
//   };

const mapStateToProps = (state: IStore) => {
	return {
		shopCard: state.shopcard.shopcard,
		customers: state.shopcard.customers,
		userPreferences: state.userPreferences,
	};
};

export function privateRoute(Component: any) {
	class LoggedInUserAccess extends React.Component<{}, {}> {
		public render() {
			return (
				<AuthConsumer>
					{({ isAuthenticated, signinRedirect }) => {
						if (!!Component && isAuthenticated()) {
							return <Component {...this.props} />;
						} else {
							signinRedirect();
							return null;
						}
					}}
				</AuthConsumer>
			);
		}
	}

	return LoggedInUserAccess;
}

export function privatePermissionRoute(Component: any, role: IUserRole['role'] = 'Admin') {
	@connect(mapStateToProps)
	class LoggedInUserAccess extends React.Component<any, {}> {
		public render() {
			const { params, userPreferences } = this.props;
			const isSiteAdmin: boolean = userPreferences.isAdministrator;
			const shopId = params.id || params.shopId; // For some routes the shop id is only id
			const officeId = params.officeId; // Usually not set
			const userRoles: IUserRole[] = userPreferences.userRoles;
			const allowedRoles = [role];
			// Admins can see pages that are for Members
			if (role == 'Member') {
				allowedRoles.push('Admin');
			}

			// Check if the user is logged in (redirect to login page if not) and then check if the user has permissions to view the page (redirect to homepage otherwise)
			return (
				<AuthConsumer>
					{({ isAuthenticated, signinRedirect }) => {
						if (!!Component && isAuthenticated()) {
							if (userRoles) {
								// Get the userRoles object that matches the current officeId or shopId
								const userRoleObject =
									userRoles.find(
										(role) =>
											role.objId === shopId ||
											role.objId === officeId ||
											(shopId && role?.objInfo?.attributes?.ShopId == shopId),
									) || null;
								if (!!isSiteAdmin || (!!userRoleObject && allowedRoles.includes(userRoleObject.role))) {
									return <Component {...this.props} />;
								} else {
									// prevent infinite loop?
									if (browserHistory.getCurrentLocation()?.pathname != '/') {
										browserHistory.replace(`/`); // TODO: find a better way to redirect (browserHistory is not the best here)
									}

									return null;
								}
							} else {
								// wait for userRoles to load
								return null;
							}
						} else {
							// user is not signed in
							signinRedirect();
							return null;
						}
					}}
				</AuthConsumer>
			);
		}
	}

	return LoggedInUserAccess;
}

export function privateRouteSwitcher(Component: any, UnauthethicatedComponent: any) {
	class LoggedInUserAccess extends React.Component<{}, {}> {
		public render() {
			return (
				<AuthConsumer>
					{({ isAuthenticated }) => {
						if (isAuthenticated()) {
							return <Component {...this.props} />;
						} else {
							return <UnauthethicatedComponent {...this.props} />;
						}
					}}
				</AuthConsumer>
			);
		}
	}

	return LoggedInUserAccess;
}
